import {Box, Chip, Group} from '@mantine/core';
import type { DatePickerInputProps, DateValue} from '@mantine/dates';
import {DatePickerInput} from '@mantine/dates';
import React from 'react';
import type {DatePreset} from './datePresets';
import { getDefaultDatePresets, resolvePresetToDate} from './datePresets';

export interface DatePickerWithPresetsProps extends Omit<DatePickerInputProps<'default'>, 'onChange' | 'value' | 'defaultValue'> {
  presets?: DatePreset[];
  value?: DateValue;
  defaultValue?: DateValue;
  onChange?: (value: DateValue) => void;
}

export const DatePickerWithPresets: React.FC<DatePickerWithPresetsProps> = ({
  presets,
  onChange,
  value,
  defaultValue,
  ...rest
}) => {
  const resolvedPresets = presets === undefined ? getDefaultDatePresets() : presets;

  return (
    <Box>
      <DatePickerInput<'default'>
        popoverProps={{zIndex: 1001}}
        {...(rest as DatePickerInputProps<'default'>)}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange as DatePickerInputProps<'default'>['onChange']}
      />
      {resolvedPresets.length > 0 && (
        <Group gap="xs" mt={4}>
          {resolvedPresets.map(preset => (
            <Chip
              key={preset.value}
              size="xs"
              variant="outline"
              checked={false}
              onChange={() => onChange?.(resolvePresetToDate(preset.value))}>
              {preset.label}
            </Chip>
          ))}
        </Group>
      )}
    </Box>
  );
};
